import { useState, useEffect } from 'react';

/**
 * Custom hook for persisting state to localStorage
 * 
 * @param {string} key - The localStorage key
 * @param {any} initialValue - The initial value
 * @returns {Array} - [storedValue, setValue] tuple
 */
export default function useLocalStorage(key, initialValue) {
  // Get initial value from localStorage or use provided initialValue
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      // Parse stored json or return initialValue if none
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      return initialValue;
    }
  });
  
  // Update localStorage when the stored value changes
  useEffect(() => {
    try {
      // Allow value to be a function for same API as useState
      const valueToStore = 
        typeof storedValue === 'function' 
          ? storedValue(storedValue) 
          : storedValue;
          
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  }, [key, storedValue]);
  
  return [storedValue, setStoredValue];
}